import { Button, Card, Form, Input, message, Upload, UploadProps } from "antd";
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from "react";
import s from './s.module.less';
import { uploadFile } from "api/common";
import Uploader from "./Uploader";
import { addOrUpdateAssessmentRule, getAssessmentRulesByAssessmentUuid } from "api/operation/assessment";
import { getUrlParam } from "utils/common";

const initialValues = [
    {
        label: '',
        image: '',
    },
    {
        label: '',
        image: '',
    }
]

export default function AssessmentFeatures() {
    const [form] = Form.useForm()
    const assessmentUuid = getUrlParam('uuid');
    const assessmentId = getUrlParam('id');

    async function queryAssessmentFeatures() {
        try {
            const { data } = await getAssessmentRulesByAssessmentUuid({
                assessmentUuid: assessmentUuid!,
            });
            if (data?.data?.assessmentFeaturesJson) {
                const features = JSON.parse(data.data.assessmentFeaturesJson);
                form.setFieldsValue({
                    items: features,
                });
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        queryAssessmentFeatures();
    }, [assessmentUuid]);

    function getValues() {
        const items = form.getFieldsValue().items;
        if (!items || items.length === 0) {
            return [];
        }
        return items
    }

    async function handleSave() {
        const values = getValues();
        const result = await addOrUpdateAssessmentRule({
            assessmentId: Number(assessmentId),
            assessmentUuid: assessmentUuid || '',
            assessmentFeaturesJson: JSON.stringify(values),
        });
        if (!result.error) {
            message.success('Save successfully');
        } else {
            message.error('Save failed. Please try again.');
        }
    }

    return <div>
        <Form
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            form={form}
            name="dynamic_form_complex"
            style={{ maxWidth: 600 }}
            autoComplete="off"
            initialValues={{ items: initialValues }}
        >
            <Form.List name="items">
                {(fields) => (
                    <div style={{ display: 'flex', rowGap: 16, flexDirection: 'column' }}>
                        {fields.map((field) => (
                            <Card
                                size="small"
                                title={`Item ${field.name + 1}`}
                                key={field.key}
                            >
                                <Form.Item label="Label" name={[field.name, 'label']}>
                                    <Input />
                                </Form.Item>

                                {/* Nest Form.List */}
                                <Form.Item label="Image" name={[field.name, 'image']}>
                                    <Uploader
                                        maxSize={1}
                                        title="Image">
                                    </Uploader>
                                </Form.Item>
                            </Card>
                        ))}
                    </div>
                )}
            </Form.List>

            <Form.Item noStyle shouldUpdate>
                {() => (
                    <Card title="JSON Preview" size="small" className={s.jsonPreview}>
                        <pre className={s.jsonCode}>
                            {JSON.stringify(getValues(), null, 2)}
                        </pre>
                    </Card>
                )}
            </Form.Item>

            <Form.Item>
                <Button className={s.saveBtn} onClick={handleSave}>Save</Button>
            </Form.Item>
        </Form>

    </div>;
}